export default [{
    text: 'Микрорайонный',
    value: 'microdistrict'
}, {
    text: 'Окружной',
    value: 'okrug'
}, {
    text: 'Районный',
    value: 'district'
}, {
    text: 'Региональный',
    value: 'regional'
}, {
    text: 'Суперокружной',
    value: 'superOkrug'
}, {
    text: 'Суперрегиональный',
    value: 'superRegional'
}];
